import { Component, OnInit, Input, Output, ViewChild, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { UtilService } from '../../util/util.service';
import {
  ArrayObjectValueAccessor,
  CreateArrayObjectValueAccessorProvider,
  CreateArrayObjectValueValidationProvider,
} from '../value-accessors/array-object-value-accessor';
import { SelectableItem } from './selectable-item.model';

@Component({
  selector: 'wl-list-builder',
  templateUrl: 'list-builder.component.html',
  styleUrls: ['list-builder.component.css'],
  providers: [CreateArrayObjectValueAccessorProvider(ListBuilderComponent), CreateArrayObjectValueValidationProvider(ListBuilderComponent)],
    standalone: false
})
export class ListBuilderComponent extends ArrayObjectValueAccessor<any> implements OnInit {
  // input of values that will be wrapped in available items
  @Input() public set availableValues(value: Array<any>) {
    if (value) {
      this.availableItems = new Array<SelectableItem<any>>();
      value.forEach(x => {
        let selItem = new SelectableItem();
        if (this.valueMember) selItem.Value = x[this.valueMember];
        selItem.Data = x;
        this.setItemDisplayText(selItem);
        this._utilService.insertOrdered(this.availableItems, selItem, 'DisplayText');
        //this.availableItems.push(selItem);
      });
    }
  }
  // attribute indicates what member to use as the display string.
  @Input() public displayMember: string;
  @Input() public availableValuesHeader: string;
  @Input() public selectedValuesHeader: string;
  // attribute indicates what member to use as the return value array (optional).
  @Input() public valueMember: any;
  @Input() public sort: boolean;

  public assignedItems: Array<SelectableItem<any>>;
  public availableItems: Array<SelectableItem<any>>;

  public constructor(private _utilService: UtilService) {
    super();
    this.availableValues = new Array<any>();
    this.assignedItems = new Array<SelectableItem<any>>();
    this.availableItems = new Array<SelectableItem<any>>();
    this.displayMember = '';
    this.availableValuesHeader = '';
    this.selectedValuesHeader = '';
    this.sort = false;
  }

  ngOnInit() {}

  public assignSelectedItems = (): void => {
    for (let selItem of this.availableItems.sort((x, y) => {
      if (x.DisplayText > y.DisplayText) return 1;
      if (x.DisplayText < y.DisplayText) return -1;
      return 0;
    })) {
      if (selItem.Selected && !this._utilService.arrayContainsEntry(this.assignedItems, 'Data', selItem.Data)) {
        let addedSi = new SelectableItem<any>();
        addedSi.DisplayText = selItem.DisplayText;
        addedSi.Data = selItem.Data;
        addedSi.Selected = false;
        addedSi.Value = selItem.Value;
        this._utilService.insertOrdered(this.assignedItems, addedSi, 'DisplayText');
        //this.assignedItems.push(addedSi);
      }
      selItem.Selected = false;
    }

    this.updateValueFromAssignedItems();
  };

  public unassignSelectedItems = (): void => {
    let unselected = new Array<SelectableItem<any>>();

    for (let ac of this.assignedItems) {
      if (ac.Selected == false) {
        unselected.push(ac);
      }
    }
    this.assignedItems = unselected;

    this.updateValueFromAssignedItems();
  };

  public toggleItemSelected = (selectableItem: SelectableItem<any>): void => {
    if (selectableItem.Selected == true) {
      selectableItem.Selected = false;
    } else {
      selectableItem.Selected = true;
    }
  };

  ngOnChanges(changes: SimpleChanges) {
    this.updateSelectedItemsFromValue();
  }

  modelChange(data: Array<any>) {
    this.value = data;
    this.updateSelectedItemsFromValue();
    this.emitOutputObject();
  }

  emitOutputObject = (): void => {};

  public updateSelectedItemsFromValue = (): void => {
    this.assignedItems = new Array<any>();
    for (let v of this.value) {
      let selItem = new SelectableItem<any>();
      // we're using value member. so that means we need to look up our source
      if (this.valueMember) {
        let availableItem = this.availableItems.find(x => x.Value == v);
        if (availableItem) {
          selItem.Data = availableItem.Data;
          selItem.Value = availableItem.Value;
        }
      } else selItem.Data = v;
      this.setItemDisplayText(selItem);
      this.assignedItems.push(selItem);
    }
  };

  public updateValueFromAssignedItems = (): void => {
    this.value = new Array<string>();
    for (let selectedItem of this.assignedItems) {
      if (this.valueMember) this.value.push(selectedItem.Value);
      else this.value.push(selectedItem.Data);
    }
  };

  // sets the displaytext of the given item
  private setItemDisplayText = (item: SelectableItem<any>, data: any = null): void => {
    if (!data && item.Data) data = item.Data;
    if (data) {
      if (this.displayMember) item.DisplayText = item.Data[this.displayMember];
      else item.DisplayText = item.Data.toString();
    }
  };
}
